import { Fragment, useState, useEffect } from 'react'

import emitter from 'garden/src/js/utils/emitter'

import { PriceTag as BasePriceTag } from 'catalog/pages/Product/components/PriceTag'

const withPropsFromEvent = (Component, event) => props => {
  const [propsFromEvents, setPropsFromEvents] = useState()
  useEffect(() => {
    emitter.on(event, data => {
      setPropsFromEvents(data)
    })
  }, [propsFromEvents])
  return <Component {...props} {...propsFromEvents} />
}

const PriceTag = props => {
  const hasFromPrice = Boolean(props.fromPriceIntegers)

  return (
    <Fragment>
      <BasePriceTag
        isAssistedSale={Boolean(props.isAssistedSale)}
        isBlackWeekend={Boolean(props.isBlackWeekend)}
        hidePrice={Boolean(props.hidePrice)}
        isSoldOut={Boolean(props.isSoldOut)}
        isPromotional={hasFromPrice}
        toPrice={{
          integers: props.toPriceIntegers,
          decimals: props.toPriceDecimals
        }}
        regionPrice={{
          integers: props.regionPriceIntegers,
          decimals: props.regionPriceDecimals
        }}
        fromPrice={{
          integers: props.fromPriceIntegers,
          decimals: props.fromPriceDecimals
        }}
        discount={parseFloat(props.discountPercentage, 10)}
        unit={props.unit}
        installments={{
          amount: parseInt(props.installmentsAmount, 10),
          value: props.installmentsValue
        }}
        brandedInstallments={{
          amount: parseInt(props.brandedInstallmentsAmount, 10)
        }}
        shopName={props.shopName}
        hasCrossServices={Boolean(props.hasCrossServices)}
        isServicesEnabled={Boolean(props.isServicesEnabled)}
        packagingUnit={props.packagingUnit}
        packagingPackaging={props.packagingPackaging}
        packagingLabel={props.packagingLabel}
        packagingPriceIntegers={props.packagingPriceIntegers}
        packagingPriceDecimals={props.packagingPriceDecimals}
      />

      <div className="product-price-offline-notice show-only-offline">
        Você precisa se conectar à Internet para ver nossos preços.
      </div>
    </Fragment>
  )
}

export default withPropsFromEvent(PriceTag, 'buybox:sellerChange')
